import { h } from "preact";
import { Island } from "../ui/layout/Island.js";
import { markups as allMarkups } from "../../data/markups.js";
import { capitalize, formatPrice } from "../../utils/format.js";

/**
 * Таблица итогов.
 *
 * Пропсы:
 *   title         — название продукта ("ПВД пакеты")
 *   state         — состояние калькулятора
 *   totalPrice    — итоговая цена (число)
 */
export function Results({ title, state, totalPrice }) {
  const totalQuantity = state.quantity || state.quantity_manual;

  const rows = [
    ["Тип", title],
    ["Плотность", state.density ? `${state.density}мкм` : null],
    ["Ручка", state.handle ? capitalize(state.handle) : null],
    ["Размер", `${state.size}см`],
    ["Цвет", capitalize(state.color)],
    [
      "Нанесение",
      `${state.face_colors} + ${state.rear_colors}` +
        (state.same_print ? ", одинаковые макеты" : ""),
    ],
    [
      "Наценки",
      state.markups.map((idx) => allMarkups[idx]?.title).filter(Boolean),
    ],
  ].filter(([, value]) => value && (Array.isArray(value) ? value.length : true));

  return h(Island, { title: "Итог", classes: "w-full" },
    h("div", { class: "results" },
      h("dl", { class: "results__list" },
        rows.map(([label, value], i) =>
          h("div", { key: i, class: "results__row" },
            h("dt", { class: "results__label" }, label),
            h("dd", { class: "results__value" },
              Array.isArray(value) ? value.join(", ") || "—" : value
            )
          )
        )
      ),

      h("div", { class: "results__total" },
        h("div", { class: "results__total-row" },
          h("span", { class: "results__total-label" }, "Количество"),
          h("span", { class: "results__total-value" }, `${totalQuantity} шт.`)
        ),
        h("div", { class: "results__total-row results__total-row--main" },
          h("span", { class: "results__total-label-main" }, "Стоимость"),
          h("span", { class: "results__total-value-main" }, formatPrice(totalPrice))
        )
      )
    )
  );
}
